import PropTypes from 'prop-types';

import { cn } from '#/lib/utils';
import { Input } from '#/modules/commonComponents/form/Input';
import ListFieldMobileLabel from '#/modules/commonComponents/form/ListFieldMobileLabel';
import { getNestedError } from '#/modules/commonComponents/form/formFieldUtils';

/**
 * list 一般 Input（非 Floating）：register + 有錯才 `.form_error`；
 * 可選 `mobileLabel`（內部用 ListFieldMobileLabel）。
 * `mobileLabelClassName`：轉傳給 ListFieldMobileLabel（覆寫隱藏斷點）。
 * `suppressInlineError`：列上不渲染 form_error，仍保留紅框／aria-invalid。
 */
const PlainRegisteredInput = ({
  id,
  register,
  errors,
  type = 'text',
  placeholder,
  mobileLabel,
  mobileLabelClassName,
  ariaLabel,
  readOnly = false,
  min,
  max,
  step,
  registerOptions,
  className,
  suppressInlineError = false,
}) => {
  const fieldError = getNestedError(errors, id);
  const registerProps = register(id, registerOptions);
  const hasError = Boolean(fieldError);

  return (
    <div className="min-w-0 w-full">
      {mobileLabel ? (
        <ListFieldMobileLabel
          hasError={hasError}
          className={mobileLabelClassName}
        >
          {mobileLabel}
        </ListFieldMobileLabel>
      ) : null}
      <Input
        id={id}
        type={type}
        placeholder={placeholder}
        readOnly={readOnly}
        min={min}
        max={max}
        step={step}
        aria-invalid={hasError ? true : undefined}
        className={cn(
          'w-full',
          'h-12.5',
          hasError && 'placeholder:text-red-500',
          readOnly && 'readonly',
          className,
        )}
        {...registerProps}
        aria-label={ariaLabel}
      />
      {!suppressInlineError && hasError ? (
        <p className="form_error">
          {fieldError.message || null}
        </p>
      ) : null}
    </div>
  );
};

PlainRegisteredInput.propTypes = {
  id: PropTypes.string.isRequired,
  register: PropTypes.func.isRequired,
  errors: PropTypes.object,
  type: PropTypes.string,
  placeholder: PropTypes.string,
  mobileLabel: PropTypes.string,
  mobileLabelClassName: PropTypes.string,
  ariaLabel: PropTypes.string,
  readOnly: PropTypes.bool,
  min: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  max: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  step: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  registerOptions: PropTypes.object,
  className: PropTypes.string,
  suppressInlineError: PropTypes.bool,
};

export default PlainRegisteredInput;
